enum ModelDetailsConfigKeys {
  ActiveTab = 'activeTab',
}

enum ModelDetailsTabs {
  Summary = 'Summary',
  Holdings = 'Holdings',
}

interface ModelDetailsConfig {
  [ModelDetailsConfigKeys.ActiveTab]: ModelDetailsTabs
}

export const defaultModelDetailsConfig: ModelDetailsConfig = {
  [ModelDetailsConfigKeys.ActiveTab]: ModelDetailsTabs.Summary,
}
